import { Box, Tab, Tabs } from '@mui/material';
import React, { useLayoutEffect } from 'react';
import { useAppSelector } from '../../store';
import { useTranslation } from 'react-i18next';
import ShowContainer from '../material-ui/ShowContainer';

export default function TabsCurrencies({
  customCurrencies,
  currency,
  setCurrency,
  defaultCurrency
}) {
  const { t } = useTranslation();
  const currenciesInfo = useAppSelector((state) => state.user.info.currency);
  const allCurrencies = Object.keys(currenciesInfo);

  const currencies = customCurrencies || allCurrencies;

  const handleChange = (_, newValue) => setCurrency(newValue);

  useLayoutEffect(() => {
    if (currency) return;
    setCurrency(defaultCurrency || currencies[0]);
  }, [defaultCurrency]);

  return (
    <Box mt={1} sx={{ backgroundColor: (theme) => theme.palette.grey[100], width: '100%' }}>
      <ShowContainer condition={currency}>
        <Tabs
          value={currency}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          sx={{ maxWidth: '95svw', minHeight: '40px' }}
          allowScrollButtonsMobile>
          {currencies.map((tab) => {
            return <Tab label={t(tab)} sx={{ minHeight: '40px' }} value={tab} key={tab} />;
          })}
        </Tabs>
      </ShowContainer>
    </Box>
  );
}
